import { Currency } from "@/types/currency";

type RiskyNumber = string | number | undefined;

export const sanitizeNumber = (amount: RiskyNumber, defaultValue = 0) => {
    let sanitizedAmount = defaultValue;

    if (typeof amount === 'number') {
        sanitizedAmount = amount;
    } else if (typeof amount === 'string') {
        const draft = Number(amount);
        if(typeof draft === 'number') {
            sanitizedAmount = draft;
        } 
    }

    return sanitizedAmount;
}

export const addCurrency = (amount: RiskyNumber, currency: keyof typeof Currency, decimals?: number,) => {
    const fixedAmount = sanitizeNumber(amount).toFixed(decimals ?? 2);

    let currencySymbol = '';
    if (currency === Currency.NIO) currencySymbol = 'C$';
    if (currency === Currency.USD) currencySymbol = 'U$';
    
    return currencySymbol + '' + fixedAmount;
}


export const multiplyByQuantity = (amount: RiskyNumber, quantity: RiskyNumber) => {
    const sanitizedQuantity = sanitizeNumber(quantity) ?? 1;
    const sanitizedAmount = sanitizeNumber(amount) ?? 1;
    
    return sanitizedAmount * sanitizedQuantity;
}

export const sumAmounts = (amounts: RiskyNumber[]) => {
    const sanitizedAmounts = amounts.map((a) => sanitizeNumber(a));
    return sanitizedAmounts.reduce((acc, curr) => acc + curr, 0);
}

export const getPercentage = (amount: RiskyNumber, percentage: RiskyNumber) => {
    const sanitizedAmount = sanitizeNumber(amount);
    const sanitizedPercentage = sanitizeNumber(percentage);

    return (sanitizedAmount * sanitizedPercentage) / 100;
}
